// https://stackoverflow.com/questions/67511040/sentry-in-node-js-cannot-read-property-captureexception-of-undefined#comment124556209_67511040
import * as Sentry from '@sentry/nextjs';
import type { Extras } from '@sentry/core';

import { type AxiosError } from 'axios';
import { httpResponseCodes } from '@/utils/api/codeConsts';
import { traceIDHeaderKey } from '@/utils/api/clearApiClient';
import { createErrorWithCause } from '@/utils/createErrorWithCause';

class ErrorLogger {
  logError(error: Error, extra?: Extras) {
    return Sentry.captureException(error, {
      extra,
    });
  }

  logCrash(error: Error, extra?: Extras) {
    return this.logError(error, { ...extra, level: 'fatal' });
  }

  logApiError(error: AxiosError) {
    if (!error.config) {
      Sentry.captureException(createErrorWithCause('API Error w/o config', error));

      return;
    }

    if (
      error.status &&
      (error.status < httpResponseCodes.BAD_REQUEST || error.status >= httpResponseCodes.INTERNAL_SERVER_ERROR)
    ) {
      Sentry.captureException(
        createErrorWithCause(`API Exception ${error.config.method} ${error.config.url}: ${error.status}`, error),
        {
          extra: {
            traceId: error.config.headers[traceIDHeaderKey],
            response: error.response?.data ? JSON.stringify(error.response?.data) : null,
          },
        },
      );
    }
  }
}

const errorLogger = new ErrorLogger();

export default errorLogger;
